<template>
  <main-template>
    <v-row>
      <v-col>
        <span class="text-h4">Diário CAEE</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0 pb-0">
        <div class="d-flex mb-2 justify-space-between">
          <v-btn
            id="gestoesDeAtendimentosCAEE.criarVinculoBtn"
            color="success"
            @click="criarGestaoDeAula"
            class="mr-2"
            v-show="$can(['gestoesDeAulasCAEE.criar', 'gestoesDeAulasCAEE.*'])"
            >Criar Vínculo CAEE</v-btn
          >
          <v-spacer />
          <v-text-field
            id="gestoesDeAtendimentosCAEE.searchInput"
            v-model="search"
            class="ml-2 search-input"
            append-icon="mdi-magnify"
            label="Pesquisar..."
            solo
            dense
            single-line
            hide-details
          />
        </div>
      </v-col>
      <v-col class="pt-0">
        <v-data-table
          :headers="table.headers"
          :items="gestoesList"
          :loading="carregandoGestoes"
          :items-per-page="10"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:body="{ items }">
            <tbody name="scroll-x-transition" is="transition-group" duration="150">
              <tr
                :class="parseInt(vinculo.notifiq, 10) === 1 ? 'green lighten-5' : ''"
                v-for="vinculo of items"
                :key="vinculo.id"
              >
                <td>{{ vinculo.id }}</td>
                <td>{{ vinculo.profissional ? vinculo.profissional.nome : "- - -" }}</td>
                <td>
                  {{
                    vinculo.usuario && vinculo.usuario.roles && vinculo.usuario.roles.length
                      ? vinculo.usuario.roles[0].name
                      : "- - -"
                  }}
                </td>

                <td>
                  <v-btn id="gestoesDeAtendimentosCAEE.turmaDescricaoBtn" text>
                    {{ vinculo.turma.descricao }}
                  </v-btn>
                  <v-chip
                    v-if="parseInt(vinculo.notifiq, 10) === 1"
                    label
                    class="white--text"
                    color="green darken-4"
                    x-small
                  >
                    NOTIFIQ
                  </v-chip>
                </td>
                <td class="text-center">
                  {{ vinculo.turma.matriculas_count }}/{{ vinculo.turma.qtd }}
                </td>

                <td width="7%">
                  <div class="text-center">
                    <v-menu :close-on-content-click="false" :nudge-width="100" offset-x>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          id="gestoesDeAtendimentosCAEE.acoesBtn"
                          x-small
                          color="indigo"
                          dark
                          v-bind="attrs"
                          v-on="on"
                        >
                          AÇÕES
                        </v-btn>
                      </template>
                      <v-card class="mx-auto" max-width="430">
                        <v-list>
                          <v-list-item>
                            <v-list-item-avatar color="primary"> </v-list-item-avatar>

                            <v-list-item-content>
                              <v-list-item-title>{{
                                vinculo.profissional && vinculo.profissional.nome
                                  ? vinculo.profissional.nome
                                  : "- - -"
                              }}</v-list-item-title>
                              <v-list-item-subtitle
                                >{{ vinculo.turma.descricao ? vinculo.turma.descricao : "- - -" }} /
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                        <v-divider></v-divider>
                        <!-- item -->
                        <v-list>
                          <v-list-item-group
                            color="primary"
                            v-if="
                              !vinculo.estaDeletado &&
                              $can(['gestoesDeAulasCAEE.visualizar', 'gestoesDeAulasCAEE.*'])
                            "
                          >
                            <v-list-item
                              id="gestoesDeAtendimentosCAEE.visualizarBtn"
                              @click="() => visualizarTurma(vinculo)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-book</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Lançamentos</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <v-list-item-group
                            color="primary"
                            v-if="
                              !vinculo.estaDeletado &&
                              $can(['gestoesDeAulasCAEE.atualizar', 'gestoesDeAulasCAEE.*'])
                            "
                          >
                            <v-list-item
                              id="gestoesDeAtendimentosCAEE.editarBtn"
                              @click="() => editarGestaoDeAula(vinculo)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-edit</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Editar diário CAEE</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                          <!-- item -->
                          <!-- item -->
                          <v-list-item-group
                            color="primary"
                            v-if="
                              !vinculo.estaDeletado &&
                              $can(['gestoesDeAulasCAEE.deletar', 'gestoesDeAulasCAEE.*'])
                            "
                          >
                            <v-list-item
                              id="gestoesDeAtendimentosCAEE.deletarBtn"
                              @click="() => deletarGestaoDeAula(vinculo)"
                            >
                              <v-list-item-icon>
                                <v-icon small>fa fa-trash</v-icon>
                              </v-list-item-icon>
                              <v-list-item-content>
                                <v-list-item-title>Deletar diário CAEE</v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </v-list-item-group>
                        </v-list>
                      </v-card>
                    </v-menu>
                  </div>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>

        <e-paginate
          id="gestoesDeAtendimentosCAEE.paginacaoPaginate"
          :current_page="paginate.current_page"
          :last_page="paginate.last_page"
          @changeActionResponse="listarGestoes"
          :search="search"
          :pageNumber="parseInt(page_number)"
        >
        </e-paginate>
      </v-col>
    </v-row>
    <e-selecionar-gestao-modal
      id="gestoesDeAtendimentosCAEE.selecionarGestaoModal"
      :dialog="dialog"
      :turma_id="turma_id"
      @dialogChange="dialog = $event"
    ></e-selecionar-gestao-modal>
  </main-template>
</template>

<script>
import { dataTableFilter } from "@/plugins/searchQuery";
import Turma from "@/Models/Turma";
import GestaoDeAula from "@/Models/GestaoDeAula";

export default {
  data() {
    return {
      page_number: 0,
      carregandoGestoes: false,
      dialog: false,
      dataTableFilter,
      search: "",
      paginate: {
        current_page: 0,
        last_page: 0,
      },
      gestoesList: [],
      gestoesDeAulasList: [],
      turma_id: null,
      table: {
        headers: [
          { text: "#", value: "id" },
          { text: "Profissional", value: "profissional" },
          { text: "Tipo", value: "tipo" },
          { text: "Turma", value: "turma" },
          { text: "Quantidade de alunos", value: "quantidade", sortable: false },
          { text: "", value: "actions", sortable: false, width: "200px" },
        ],
      },
    };
  },
  async mounted() {
    this.$loaderService.open("Carregando Vínculos CAEE");
    try {
      await this.listarGestoes(this.page_number);
    } catch (error) {
      this.$handleError(error);
    }
    this.$loaderService.close();
  },
  watch: {
    carregandoGestoes(value) {
      if (value && this.gestoesList.length === 0) {
        this.$loaderService.open("Carregando dados");
      } else {
        this.$loaderService.close();
      }
    },
    async search(val) {
      if (val.length > 1) {
        await this.listarGestoes(0, val);
      }
      if (!val) {
        await this.listarGestoes(0);
      }
    },
  },
  methods: {
    async listarGestoes(pageNumber, query = null) {
      this.carregandoGestoes = true;
      this.$loaderService.open("Carregando dados");
      try {
        const response = await this.$services.gestoesDeAtendimentosCAEEService.syncAll(
          pageNumber,
          query
        );
        this.gestoesList = await response.data.map((gestao) => new GestaoDeAula(gestao));
        this.gestoesList = this.gestoesList.map((vinculo) => {
          return { ...vinculo, selected: false };
        });
        this.paginate = response;
      } catch (error) {
        this.$loaderService.close();
        this.$handleError(error);
      }
      this.carregandoGestoes = false;
      this.$loaderService.close();
    },
    visualizarTurma(turma) {
      const gestaoDeAulasId = turma.id;
      const turmaId = turma.turma.id;

      this.$router.push({
        name: "relatorios.visualizarDiarioCAee",
        params: {
          gestaoDeAulasId,
          turmaId,
        },
      });
    },
    criarGestaoDeAula() {
      this.$router.push({ name: "gestoesDeAulasCAEE.newEdit" });
    },
    editarGestaoDeAula(turma) {
      this.$router.push({
        name: "gestoesDeAulasCAEE.edit",
        params: { gestaoDeAulasId: turma.id },
      });
    },
    async deletarGestaoDeAula(turma) {
      this.$modals.danger({
        title: "Cuidado!",
        message: "Tem certeza que deseja apagar este diário caee?",
        confirmationCode: turma.id,
        confirmationMessage: `Por favor, digite <strong>${turma.id}</strong> para confirmar`,
        buttons: [
          {
            text: "Cancelar",
            callback: () => {
              this.$modals.close();
            },
            props: {
              id: "gestoesDeAtendimentosCAEE.cancelarDelecaoBtn",
              color: "warning",
              small: true,
            },
          },
          {
            text: "Confirmar",
            disableIfCodeDoesntMatch: true,
            callback: async () => {
              this.$modals.close();
              this.$loaderService.open("Deletando Diário AEE");
              try {
                await this.$services.gestoesDeAtendimentosCAEEService.deletarGestaoDeAula(turma);
                this.$toast.success("Diário CAEE deletado com sucesso");
                await this.listarGestoes();
              } catch (error) {
                this.$handleError(error);
              }
              this.$loaderService.close();
            },
            props: {
              id: "gestoesDeAtendimentosCAEE.confirmarDelecaoBtn",
              color: "error",
              // text: true,
              small: true,
            },
          },
        ],
      });
    },
  },
};
</script>

<style></style>
